























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import QDatePicker from "@/components/Booking/QDatePicker.vue";
import { mapState, mapGetters } from "vuex";
import BusinessTagCreate from "@/components/Business/BusinessTagCreate.vue";

@Component({
  components: {
    QDatePicker,
    BusinessTagCreate
  },
  computed: {
    ...mapState({
      loading: "loading"
    }),
    ...mapState("ServiceItem", {
      serviceItems: "serviceItems"
    }),
    ...mapGetters("BusinessTag", {
      tagList: "mappedList"
    })
  }
})
export default class BookingCreateBookingCandidateFormFields extends Vue {
  @Prop() readonly candidate!: Candidate;
  @Prop() readonly index!: number;
  @Prop() readonly disabled!: boolean;

  tagList!: Model[];
  serviceItems!: Model[];
  loading!: boolean;

  localCandidate: Candidate | null = null;

  additionalService = "";

  showAdditionalService = false;
  showAddNewTag = false;

  get additionalServices() {
    return this.serviceItems
      .filter(serviceItem => serviceItem.key !== "assessment")
      .map(serviceItem => {
        return {
          object_id: serviceItem.object_id,
          key: serviceItem.key,
          name: serviceItem.name
        };
      });
  }

  @Watch("candidate", { deep: true, immediate: true })
  watchCandidate() {
    this.initLocalData();
  }

  initLocalData() {
    this.localCandidate = Object.assign({}, this.candidate);
  }

  failedRulesToErrorMessage(failedRules: { [key: string]: string }) {
    const errorMessage: string[] = [];
    for (const [key, value] of Object.entries(failedRules)) {
      errorMessage.push(value);
    }
    return errorMessage;
  }

  updateBookingCandidate() {
    this.$emit("update", this.localCandidate);
    this.close();
  }

  close() {
    this.$emit("close");
  }

  async beforeMount() {
    await this.$store
      .dispatch("Document/fetch", "additional-services")
      .then(response => {
        this.additionalService = response.data.data;
      });
  }
}
